import { defaultSearchSuggestions } from '../interfaces';

export const filterSuggestions = (suggestionsArray: defaultSearchSuggestions[] = []) =>
  suggestionsArray?.filter(item => !!item?.term && !!item?.href);
